howspace.components.range = (() => {
    'use strict';

    const handleTickClick = e => {
        const tick = e.target;
        const range = tick.closest('.howspace-range');

        if (range.classList.contains('disabled')) {
            return;
        }

        const leftInput = range.querySelector('.howspace-range-input-left');
        const rightInput = range.querySelector('.howspace-range-input-right');
        const tickValue = parseInt(tick.innerText);
        const deltaLeft = Math.abs(parseInt(leftInput.value) - tickValue);
        const deltaRight = Math.abs(parseInt(rightInput.value) - tickValue);
        if (deltaLeft < deltaRight) {
            leftInput.value = tickValue;
        } else {
            rightInput.value = tickValue;
        }
        fillRange(range);
    };

    const handleLeftInput = e => {
        const leftInput = e.currentTarget;
        const rightInput = leftInput.nextElementSibling;
        const max = parseInt(rightInput.value) - parseInt(rightInput.step);
        if (leftInput.value > max) {
            leftInput.value = max;
        }
        fillRange(leftInput.parentElement);
    };

    const handleRightInput = e => {
        const rightInput = e.currentTarget;
        const leftInput = rightInput.previousElementSibling;
        const min = parseInt(leftInput.value) + parseInt(leftInput.step);
        if (rightInput.value < min) {
            rightInput.value = min;
        }
        fillRange(leftInput.parentElement);
    };

    const fillRange = range => {
        const leftInput = range.querySelector('.howspace-range-input-left');
        const rightInput = range.querySelector('.howspace-range-input-right');
        const steps = parseInt(leftInput.max) - parseInt(leftInput.min);
        const leftPosition = (parseInt(leftInput.value) - parseInt(leftInput.min)) / steps * 100;
        const rightPosition = (parseInt(rightInput.value) - parseInt(rightInput.min)) / steps * 100;
        range.style.setProperty('--track-fill-left-position', leftPosition + '%');
        range.style.setProperty('--track-fill-right-position', 100 - rightPosition + '%');
    };

    return {
        init: (elem) => {
            elem.findIncludingSelf('.howspace-range:not(.howspace-range-initialized)').each(function () {
                const range = $(this);
                range.addClass('howspace-range-initialized');
                range.on('click', '.howspace-range-tick', handleTickClick);
                range.find('.howspace-range-input-left').on('input', handleLeftInput);
                range.find('.howspace-range-input-right').on('input', handleRightInput);
                fillRange(range[0]);
            });
        },
        destroy: (elem) => {
            elem.findIncludingSelf('.howspace-range.howspace-range-initialized').each(function () {
                const range = $(this);
                range.removeClass('howspace-range-initialized');
                range.off('click', '.howspace-range-tick', handleTickClick);
                range.find('.howspace-range-input-left').off('input', handleLeftInput);
                range.find('.howspace-range-input-right').off('input', handleRightInput);
            });
        }
    };

})();
